import { Dropdown, Menu } from 'antd';
import { starUIOps, starColors } from 'views/Conversation/ConvList/starData';
import { StarFilled, StarOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import useConversationOps from 'hooks/business/useConversationOps';
import { useCallback, useEffect, useState } from 'react';
import { useMakeConversationCache } from 'hooks/business/conversation';

interface StarItemProps {
  conversation: Conversation.Conversation;
  value: Conversation.Conversation['colorAsterisk'];
  onChange: (colorAsterisk: Conversation.Conversation['colorAsterisk']) => void;
}

const StarItem = (props: StarItemProps) => {
  const { conversation, value, onChange } = props;

  const { t } = useTranslate();
  const { modifyConversation } = useConversationOps();
  const setConversation = useMakeConversationCache('set');

  const handleClick = useCallback(() => {
    modifyConversation(
      conversation.conversationId,
      {
        asterisk: value,
      },
      () => {
        onChange(value);
        setConversation({ ...conversation, colorAsterisk: value });
      },
    );
  }, [modifyConversation, conversation, value, onChange, setConversation]);

  return (
    <Menu.Item onClick={handleClick}>
      {value === 'NO_STAR' ? (
        <StarOutlined style={{ marginRight: '6px' }} />
      ) : (
        <StarFilled style={{ color: starColors[value], marginRight: '6px' }} />
      )}
      {t(`filter.${value}`)}
    </Menu.Item>
  );
};

export function Star(props: { conversation: Conversation.Conversation }) {
  const { conversation } = props;
  const { colorAsterisk } = conversation;

  const [stColorAsterisk, setStColorAsterisk] = useState(colorAsterisk);

  useEffect(() => {
    if (stColorAsterisk !== colorAsterisk) {
      setStColorAsterisk(colorAsterisk);
    }
  }, [colorAsterisk, stColorAsterisk]);

  return (
    <Dropdown
      overlay={
        <Menu>
          {starUIOps.map((colorAsterisk) => (
            <StarItem
              key={colorAsterisk}
              conversation={conversation}
              value={colorAsterisk}
              onChange={setStColorAsterisk}
            />
          ))}
        </Menu>
      }
    >
      {stColorAsterisk === 'NO_STAR' ? (
        <StarOutlined />
      ) : (
        <StarFilled style={{ color: starColors[stColorAsterisk] }} />
      )}
    </Dropdown>
  );
}
